import { render, staticRenderFns } from "./BranchSettings.vue?vue&type=template&id=d06a0114&scoped=true&"
import script from "./BranchSettings.vue?vue&type=script&lang=ts&"
export * from "./BranchSettings.vue?vue&type=script&lang=ts&"
import style0 from "./BranchSettings.vue?vue&type=style&index=0&id=d06a0114&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06a0114",
  null
  
)

export default component.exports